import { render, staticRenderFns } from "./Licences.vue?vue&type=template&id=43110d95&scoped=true&"
import script from "./Licences.vue?vue&type=script&lang=js&"
export * from "./Licences.vue?vue&type=script&lang=js&"
import style0 from "./Licences.vue?vue&type=style&index=0&id=43110d95&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43110d95",
  null
  
)

export default component.exports